import { BrowserRouter, Route, Routes } from "react-router-dom";
import { getDOMComponentBaseName, getDOMComponentDomain } from "helpers";
import useAPI from "hooks/useAPI";
import { Loader } from "shared";
import BlogPage from "./components/BlogPage";
import { TFiltersData } from "./Blog.types";
import BlogItem from "./components/BlogItem";

type TBlogProps = {
  rootElement: HTMLElement;
};

function Blog({ rootElement }: TBlogProps) {
  const basename = getDOMComponentBaseName(rootElement);
  const domain = getDOMComponentDomain(rootElement) ?? "";
  const apiBaseUrl = domain + "/api/sitecore/NewBlog/";
  const { data, isLoading, error } = useAPI<TFiltersData>({
    url: apiBaseUrl + "BlogFilters",
    method: "GET",
  });

  if ((error || !domain) && !isLoading) {
    return <></>;
  }

  return isLoading || !data ? (
    <Loader />
  ) : (
    <>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route
            path="/:category?"
            element={<BlogPage filtersData={data} BlogItem={BlogItem} apiBaseUrl={apiBaseUrl} />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default Blog;
